import React, { useEffect } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import { HeadingText, Card, Link } from '@paypalcorp/pp-react'
import useTracking from '../../hooks/useTracking'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

import './survey.less'

const QUALTRICS_SURVEY_ID = 'helpcenternodeweb-feedbacklink-nov2022'

function Survey() {
  const { trackClick, trackActivity } = useTracking()

  // On component mount: qualtrics feedback survey link shown fpti
  useEffect(() => {
    trackActivity({
      name: componentNames.QUALTRICS_SURVEY,
      type: fptiTypes.SUCCESS,
    })
  }, [trackActivity])

  // survey link onclick handler
  const surveyLinkOnClickHandler = (event) => {
    event.preventDefault()

    // FPTI:- qualtrics feedback survey link clicked
    const fptiOptions = {
      name: componentNames.QUALTRICS_SURVEY,
      type: fptiTypes.ON_CLICK,
      link: 'qualtrics-survey-link-clicked',
    }
    trackClick(fptiOptions)

    // Open the survey prompt
    try {
      // eslint-disable-next-line no-undef
      if (typeof PAYPAL === 'object' && PAYPAL.analytics) {
        // eslint-disable-next-line no-undef
        PAYPAL.analytics.reloadQualtrics(QUALTRICS_SURVEY_ID)
      }
    } catch (err) {
      // Error FPTI:- if there is any error on survey link click
      trackActivity({
        name: componentNames.QUALTRICS_SURVEY,
        type: fptiTypes.ERROR,
      })
    }
  }

  const renderQualtricsSurvey = () => {
    return (
      <div
        data-testid="hc-qualtrics-survey-container"
        className="hc-survey__container"
      >
        <Card className="hc-survey__container-card">
          <div className="hc-survey__container-body">
            <HeadingText size="sm" className="hc-survey__container-body-label">
              <Message id="app.helpcenter.survey.greeting" />
            </HeadingText>
            <Link
              href="#"
              onClick={(e) => surveyLinkOnClickHandler(e)}
              className="hc-survey__container-body-action__label"
              data-testid="hc-survey-container-body-action-label"
            >
              <Message id="app.helpcenter.survey.actionLabel" />
            </Link>
          </div>
        </Card>
      </div>
    )
  }

  return renderQualtricsSurvey()
}

export default Survey
